// Mock data for Audrey Egypt Young's portfolio

export const mockData = {
  author: {
    name: "Audrey Egypt Young",
    title: "Author, Editor, Ghostwriter & Founder",
    bio: "Audrey Egypt Young is a visionary author, skilled editor, and experienced ghostwriter who has dedicated her career to empowering voices and building bridges through the written word. As the founder of eBlackBookListings, she champions African American businesses and authors, creating platforms for underrepresented voices to thrive in the literary and business world.",
    headshot: "https://customer-assets.emergentagent.com/job_audrey-portfolio/artifacts/06q36ox9_Egypt%20Headshot.jpg",
    social: {
      linkedin: "#",
      instagram: "#", 
      twitter: "#"
    }
  },
  
  books: [
    {
      id: 1,
      title: "THIS OR THAT: Vol. 1 - How Well Do You Know Them",
      description: "An interactive GameBook packed with 1000 fun, thought-provoking questions that challenge how well you really know your friends, family, or anyone close to you. Perfect for game nights, road trips, and building deeper connections!",
      cover: "https://customer-assets.emergentagent.com/job_audrey-portfolio/artifacts/dezhjave_1%20THIS%20or%20THAT%20How%20Well%20Do%20You%20Know%20Them%20Vol%201.%20cover.png",
      price: 16.99,
      digitalPrice: 9.99,
      bundlePrice: 19.99,
      amazonLink: "#",
      digitalAvailable: true,
      physicalAvailable: false
    },
    {
      id: 2,
      title: "THIS OR THAT: Vol. 2 - How Well Do You Know Your Partner",
      description: "A fun and thought-provoking GameBook with 1000 questions designed to spark deeper conversations, laughter, and connection in relationships. Strengthen your bond while having endless fun!",
      cover: "https://customer-assets.emergentagent.com/job_audrey-portfolio/artifacts/rw6b567o_2%20THIS%20or%20THAT%20How%20Well%20Do%20You%20Know%20Your%20Partner%20Vol%202%20-%20cover.png",
      price: 16.99,
      digitalPrice: 9.99,
      bundlePrice: 19.99,
      amazonLink: "#",
      digitalAvailable: true,
      physicalAvailable: false
    },
    {
      id: 3,
      title: "THIS OR THAT: Vol. 3 - What Would You Prefer To Say?",
      description: "COMING SOON! A New Spin on How We Speak Through the Decades - The game that celebrates the way we talk, the way we vibe, and the way we've evolved through time. From 'Right On' in the 1970s to 'It's Giving' in the 2020s.",
      cover: "https://customer-assets.emergentagent.com/job_egypt-portfolio/artifacts/o60phml6_THIS%20or%20THAT%20Vol.%203.png",
      price: 16.99,
      digitalPrice: 9.99,
      bundlePrice: 19.99,
      amazonLink: "#",
      digitalAvailable: false,
      physicalAvailable: false,
      comingSoon: true
    },
    {
      id: 4,
      title: "THIS OR THAT: Vol. 4 - GameBook Series - How Well Do You Know Your Friends?",
      description: "COMING SOON! Get ready for 500 laugh-out-loud questions that spark imagination and endless giggles! This special edition is packed with fun choices about cartoons, kids' TV shows, movies, video games, and everything kids love most! Plus enjoy 10 Bonus Activity Pages full of puzzles, drawing challenges, word scrambles, and creative games! Perfect for Ages 8–15 | Family-Friendly | Screen-Free Fun.",
      cover: "https://customer-assets.emergentagent.com/job_egypt-portfolio/artifacts/eohhys62_THIS%20or%20THAT%20Vol.%204%20-%20GameBook%20Series.png",
      price: 16.99,
      digitalPrice: 9.99,
      bundlePrice: 19.99,
      amazonLink: "#",
      digitalAvailable: false,
      physicalAvailable: false,
      comingSoon: true
    },
    {
      id: 5,
      title: "THIS OR THAT: Vol. 5 - Guess All 10 SLANG TWINS",
      description: "COMING SOON! Same Energy Words Over the Decades: Maddd Synonyms - Featuring 500 Slang Twins from the '70s to the 2020s. This is the most fun you'll have talking trash through time.",
      cover: "https://customer-assets.emergentagent.com/job_egypt-portfolio/artifacts/fd9cg33h_THIS%20or%20THAT%20Vol.%205%20-%20GUESS%20ALL%2010%20SLANG%20TWINS%20Vol.%205.png",
      price: 16.99,
      digitalPrice: 9.99,
      bundlePrice: 19.99,
      amazonLink: "#",
      digitalAvailable: false,
      physicalAvailable: false,
      comingSoon: true
    },
    {
      id: 6,
      title: "The Mindset Shift",
      description: "COMING SOON! Rewire Your Thinking. Rebuild Your Life. Create Your Legacy. A transformational guide that helps readers break limiting beliefs and unlock a positive, wealth-building mindset.",
      cover: "https://customer-assets.emergentagent.com/job_egypt-portfolio/artifacts/pjhwtif3_THE%20MINDSET%20SHIFT%20-%20cover.png",
      price: 19.99,
      digitalPrice: 12.99,
      amazonLink: "#",
      digitalAvailable: false,
      physicalAvailable: false,
      comingSoon: true
    },
    {
      id: 7,
      title: "You Can Be a Student AND an Entrepreneur",
      description: "COMING SOON! A step-by-step playbook for students ready to turn ideas into real businesses, blending practical strategies with motivation.",
      cover: "https://customer-assets.emergentagent.com/job_audrey-portfolio/artifacts/8txz0326_3%20You%20Can%20Be%20a%20Student%20AND%20an%20Entreprenuer%20cover.jpg",
      price: 18.99,
      digitalPrice: 11.99,
      amazonLink: "#",
      digitalAvailable: false,
      physicalAvailable: false,
      comingSoon: true
    },
    {
      id: 8,
      title: "My 30 Day Gratitude Journal",
      description: "COMING SOON! A beautifully designed journal that encourages daily gratitude practice, reflection, and personal growth in just a few minutes a day.",
      cover: "https://customer-assets.emergentagent.com/job_audrey-portfolio/artifacts/1tra5l0q_8%20My%2030%20Day%20Gratitude%20Journal.png",
      price: 14.99,
      digitalPrice: 8.99,
      amazonLink: "#",
      digitalAvailable: false,
      physicalAvailable: false,
      comingSoon: true
    },
    {
      id: 9,
      title: "From Idea to Grand Opening: The Black Entrepreneur's Step-by-Step Startup Guide",
      description: "COMING SOON! Your complete roadmap to turning vision into reality. Created by eBlackBookListings, this guide empowers aspiring entrepreneurs to move from concept to company with confidence. Learn how to register your business, build your brand, market effectively, and join the growing movement of Black-owned enterprises shaping the future of commerce.",
      cover: "https://customer-assets.emergentagent.com/job_audrey-portfolio/artifacts/fnukb9sl_From%20Idea%20to%20Grand%20Opening%20Cover.png",
      price: 22.99,
      digitalPrice: 14.99,
      amazonLink: "#",
      digitalAvailable: false,
      physicalAvailable: false,
      comingSoon: true
    }
  ],

  // Digital Author Resources
  digitalResources: [
    {
      id: 1,
      title: "The Ultimate Author Facebook eCoSystem",
      subtitle: "100+ Verified Groups & Pages to Market Your Book",
      description: "A curated directory of 100+ active Facebook pages, groups and communities where authors can promote, market, and sell their books to engaged readers - complete with follower counts and live links.",
      cover: "https://customer-assets.emergentagent.com/job_audrey-portfolio/artifacts/mymisk8j_FINAL%20COVER%20ULTIMATE%20AUTHOR%20FACEBOOK%20eCoSystem.png",
      backCover: "https://customer-assets.emergentagent.com/job_audrey-portfolio/artifacts/1rargzxh_FINAL%20BACK%20COVER%20ULTIMATE%20AUTHOR%20FACEBOOK%20eCoSystem.png",
      pdfLink: "https://customer-assets.emergentagent.com/job_audrey-portfolio/artifacts/uizx6dej_THE%20ULTIMATE%20AUTHOR%20FACEBOOK%20ECOSYSTEM.pdf",
      price: 27.00,
      platforms: "100+",
      status: "available",
      category: "Facebook Marketing"
    },
    {
      id: 2,
      title: "The Ultimate Author Instagram eCoSystem", 
      subtitle: "100+ Bookstagram Accounts & Influencers",
      description: "Discover the most active book reviewers, bookstagram influencers, and Instagram communities where your book needs to be seen.",
      cover: "/api/placeholder/300/400",
      price: 27.00,
      platforms: "100+",
      status: "coming-soon",
      category: "Instagram Marketing"
    },
    {
      id: 3,
      title: "The Ultimate Author TikTok eCoSystem",
      subtitle: "100+ BookTok Creators & Viral Potential",
      description: "Connect with BookTok creators who can make your book go viral. Includes follower counts, engagement rates, and outreach strategies.",
      cover: "/api/placeholder/300/400", 
      price: 27.00,
      platforms: "100+",
      status: "coming-soon",
      category: "TikTok Marketing"
    },
    {
      id: 4,
      title: "The Ultimate Author Website eCoSystem",
      subtitle: "100+ Book Promotion Websites & Platforms",
      description: "Every website, blog, and platform where you can get your book featured, reviewed, and promoted to millions of readers.",
      cover: "/api/placeholder/300/400",
      price: 27.00, 
      platforms: "100+",
      status: "coming-soon",
      category: "Website Marketing"
    }
  ],

  // eCoSystem Bundle
  eCoSystemBundle: {
    title: "Complete Author Social Media eCoSystem",
    description: "All 4 platforms + bonuses. Everything you need to go from unknown author to bestseller in 90 days.",
    originalPrice: 174.00,
    bundlePrice: 97.00,
    savings: 77.00,
    bonuses: [
      {
        title: "30-Day Social Media Content Calendar",
        value: 47,
        description: "Never wonder what to post again. Done-for-you content ideas for all 4 platforms."
      },
      {
        title: "Platform-Specific Strategy Guides", 
        value: 67,
        description: "How to use each platform effectively. Do's and Don'ts. Posting schedules. Engagement tactics."
      },
      {
        title: "Viral Content Formula Guide",
        value: 57, 
        description: "10 proven content formulas that make books go viral on BookTok and Instagram. Copy-paste templates included."
      },
      {
        title: "Email & DM Templates",
        value: 36,
        description: "Pre-written messages for reaching out to bookstagrammers, BookTokers, and reviewers. Just customize and send."
      }
    ],
    totalValue: 381,
    guarantee: "30-day money-back guarantee"
  },

  // Shopping Cart Data
  cartItems: [],
  
  // Contact Information
  contact: {
    email: "eBlackBookListings@gmail.com", 
    phone: "+1 (555) 123-4567",
    website: "eBlackBookListings.com",
    location: "Available Worldwide"
  },

  ghostwritingServices: {
    title: "eBlackBookListings Ghostwriting Services",
    tagline: "YOU think it, MY pen writes it, YOU own it",
    subtitle: "Turn your story, expertise, and ideas into powerful books, articles, and speeches—without lifting a pen.",
    description: "At eBlackBookListings Ghostwriting Services, we specialize in bringing your voice to life. Whether you're a business leader, entrepreneur, or creative with a vision, we take your thoughts and transform them into polished, publish-ready words. From memoirs to business books, blogs to speeches—your ideas deserve the spotlight, and we make sure they shine.",
    taglineInsert: "You bring the vision, we bring the words.",
    portfolioSamples: [
      {
        title: "2 Jersey Queens Royal Review - Boyz II Men",
        description: "Concert review and entertainment coverage featuring the legendary R&B group Boyz II Men",
        type: "Concert Review",
        link: "https://customer-assets.emergentagent.com/job_audrey-portfolio/artifacts/xugrn1g2_2%20Jersey%20Queens%20Review%20-%20Boyz%20II%20Men.pages"
      },
      {
        title: "2 Jersey Queens Review - Karyn White @ City Winery NYC",
        description: "Live music review covering Karyn White's intimate performance at City Winery NYC",
        type: "Music Review",
        link: "https://customer-assets.emergentagent.com/job_audrey-portfolio/artifacts/rfaziyca_2%20Jersey%20Queens%20Review%20-%20Karyn%20White%20%40%20CITY%20WINERY%20NYC.pdf"
      }
    ],
    services: [
      {
        icon: "BookOpen",
        title: "Book Ghostwriting",
        description: "From concept to finished manuscript (nonfiction, memoirs, self-help, business)"
      },
      {
        icon: "FileEdit",
        title: "Blog & Article Ghostwriting", 
        description: "Position yourself as an expert with consistent, high-quality content"
      },
      {
        icon: "Mic",
        title: "Thought Leadership Content",
        description: "Speeches, LinkedIn posts, whitepapers, newsletters"
      },
      {
        icon: "Zap",
        title: "AI-Enhanced Copywriting",
        description: "Sales pages, social media, and polished content with speed + precision"
      }
    ],
    packages: [
      {
        id: 1,
        name: "Starter Package",
        subtitle: "For Busy Professionals",
        priceRange: "STARTING at $1,500 monthly retainer",
        price: 1500,
        features: [
          "4 high-quality blog posts OR 8 LinkedIn articles per month",
          "AI-enhanced research + human editing for accuracy & style", 
          "Written in your unique voice and tone",
          "Unlimited edits within 7 days",
          "Priority email support"
        ],
        ideal: "Perfect for entrepreneurs, coaches, or business owners who want consistent visibility but don't have time to write.",
        popular: false
      },
      {
        id: 2,
        name: "Pro Package", 
        subtitle: "For Thought Leaders",
        priceRange: "$8,000 – $15,000 (per project)",
        price: 8000,
        features: [
          "1 book manuscript up to 35,000 words (business, self-help, memoir, or nonfiction)",
          "Chapter outlines & content strategy session",
          "Writing in your authentic voice", 
          "2 full rounds of revisions",
          "Formatting for publishing (Kindle + print ready)",
          "Includes 10 social media posts pulled from your book for marketing"
        ],
        ideal: "Ideal for professionals who want to establish themselves as published authors.",
        popular: true
      },
      {
        id: 3,
        name: "Premium Package",
        subtitle: "For Authority Builders", 
        priceRange: "$25,000 – $50,000 (per project)",
        price: 25000,
        features: [
          "Complete book manuscript up to 70,000 words",
          "Ghostwritten and polished with AI + human editing",
          "Dedicated brand voice analysis",
          "3 full rounds of revisions", 
          "Publishing consultation (ISBN, layout, cover guidance)",
          "1 keynote speech",
          "1 press release",
          "20 social media captions",
          "Priority 1:1 coaching calls during the writing process"
        ],
        ideal: "Designed for CEOs, influencers, and visionaries who want to build lasting legacy and brand authority.",
        popular: false
      }
    ],
    addOns: [
      "Audiobook script + narration guidance",
      "Author website copy", 
      "Press release for book launch",
      "Done-for-you book launch strategy"
    ],
    marketingImage: "https://customer-assets.emergentagent.com/job_audrey-portfolio/artifacts/jem9ex7h_Marketing%20Now%20Offering%20Ghostwriting%20Services%20-%20flyer%281%29.png"
  },

  // Marketing & Design Portfolio
  marketingPortfolio: [
    {
      id: 1,
      title: "Beauty & Healing Promotional Flyer",
      client: "4EverLive Cosmetics - Shareen Hatcher",
      description: "Eye-catching promotional flyer featuring natural beauty products with bold typography and vibrant branding.",
      type: "Flyer Design",
      image: "https://customer-assets.emergentagent.com/job_author-portfolio-pro/artifacts/rdfqw8v6_1%20SHAREEN.png"
    },
    {
      id: 2,
      title: "Beauty & Wellness Marketing Poster",
      client: "4EverLive Cosmetics",
      description: "Professional horizontal poster showcasing natural remedies, essential oils, and beauty services with QR code integration.",
      type: "Horizontal Poster",
      image: "https://customer-assets.emergentagent.com/job_author-portfolio-pro/artifacts/2k3sx0wl_2%20SHAREEN.png"
    },
    {
      id: 3,
      title: "Promotional Discount Campaign",
      client: "4EverLive Cosmetics",
      description: "High-impact promotional material featuring 25% discount offer with product showcase and social media integration.",
      type: "Marketing Flyer",
      image: "https://customer-assets.emergentagent.com/job_author-portfolio-pro/artifacts/7vknpqgj_6%20SHAREEN.png"
    },
    {
      id: 4,
      title: "Step & Repeat Branded Backdrop",
      client: "4EverLive Cosmetics",
      description: "Professional event backdrop with repeating logo pattern - perfect for photo ops, trade shows, and branded events.",
      type: "Backdrop Design",
      image: "https://customer-assets.emergentagent.com/job_author-portfolio-pro/artifacts/iw87f00s_SHAREEN%20BACKDROP.jpeg"
    },
    {
      id: 5,
      title: "QR Code Business Cards",
      client: "4EverLive Cosmetics",
      description: "Modern business card design with integrated QR codes for seamless digital connection and brand consistency.",
      type: "Business Cards & QR Codes",
      image: "https://customer-assets.emergentagent.com/job_author-portfolio-pro/artifacts/6wy8xieq_2Shareen%20logos.png"
    },
    {
      id: 6,
      title: "Tri-Fold Brochure Design",
      client: "Learnology Education Services",
      description: "Comprehensive tri-fold brochure detailing student loan solutions and financial freedom strategies.",
      type: "Tri-Fold Brochure",
      image: "https://customer-assets.emergentagent.com/job_author-portfolio-pro/artifacts/bq7mgbnj_LEARNOLOGY%20brochure.pdf"
    },
    {
      id: 7,
      title: "Financial Future Promotional Flyer",
      client: "Learnology - Cambie Jones",
      description: "Bold promotional flyer with personalized QR code and call-to-action for financial transformation services.",
      type: "Promotional Flyer",
      image: "https://customer-assets.emergentagent.com/job_author-portfolio-pro/artifacts/kpvi4c7u_aaaTRANSFORM%20YOUR%20FINANCIAL%20FUTURE%20WITH%20CAMBIE%20JONES%20Log%20onto%20our%20website%20%281%29.png"
    },
    {
      id: 8,
      title: "Financial Freedom Marketing Flyer",
      client: "Learnology - Cambie Jones",
      description: "Professional flyer design highlighting student loan solutions with website integration and branding consistency.",
      type: "Marketing Flyer",
      image: "https://customer-assets.emergentagent.com/job_author-portfolio-pro/artifacts/3ov94vvn_TRANSFORM%20YOUR%20FINANCIAL%20FUTURE%20WITH%20CAMBIE%20JONES%20Log%20onto%20our%20website.png"
    },
    {
      id: 9,
      title: "Personalized QR Code Design",
      client: "Learnology Website",
      description: "Custom branded QR code with Learnology branding for easy digital access to website and services.",
      type: "QR Code Design",
      image: "https://customer-assets.emergentagent.com/job_author-portfolio-pro/artifacts/i9lsqkrg_Learnology%20website.png"
    },
    {
      id: 10,
      title: "Event Promotional Flyer",
      client: "Learnology - Cambie Jones",
      description: "Detailed event flyer with service information, contact details, and integrated QR code for registration.",
      type: "Event Flyer",
      image: "https://customer-assets.emergentagent.com/job_author-portfolio-pro/artifacts/s801lfg7_LEARNOLOGY%20FLYER%20-%20Cambie%20Jones%20%281%29.pdf"
    }
  ],

  eBlackBookListings: {
    title: "eBlackBookListings Platform",
    description: "Supporting African American businesses and authors through a comprehensive platform that provides visibility, resources, and community connections.",
    mission: "Our mission is to create opportunities, amplify voices, and build sustainable success for Black-owned businesses and emerging authors.",
    logo: "https://customer-assets.emergentagent.com/job_4ba17392-007a-438c-b296-76e166f0f0cf/artifacts/67pzcjdk_eBlackBookListings.png"
  },

  theMovementMagazine: {
    title: "The Movement Magazine",
    tagline: "Where culture, creativity, and change-makers collide.",
    founder: "Audrey Egypt Young, Founder/Editor in Chief",
    yearsActive: "18+ years",
    description: "Founded by Audrey Egypt Young, The Movement Magazine has been a platform for culture, inspiration, and empowerment for over 18 years. What started as an online publication has grown into a bold voice that spotlights A-list celebrities, entrepreneurs, activists, and everyday trailblazers who are reshaping the world.",
    mission: "Our mission is simple: to ignite conversations, celebrate excellence, and amplify voices that deserve to be heard. Each issue blends powerful storytelling, striking visuals, and thought-provoking features that inspire readers to dream bigger, think differently, and take action.",
    statement: "With exclusive interviews, lifestyle content, and revolutionary concepts, The Movement Magazine isn't just media—it's a movement."
  },

  magazineWork: [
    {
      id: 1,
      title: "Tyrese Gibson Cover Story",
      publication: "The Movement Magazine Vol. 2",
      description: "Having it ALL - Spirituality, Music, Movies, Book & Fatherhood. Memorial Edition featuring 10 Power Moves by Men of Color.",
      image: "https://customer-assets.emergentagent.com/job_audrey-portfolio/artifacts/mujiqhfq_Cover%20ONLY%20TheMovementMag%20Vol2.jpg",
      issueLink: "#",
      featured: true
    },
    {
      id: 2,
      title: "Kevin Hart Exclusive Interview", 
      publication: "The Movement Magazine Vol. 5",
      description: "You Got to Have Hart to Stay on Top - An intimate conversation with one of comedy's biggest stars.",
      image: "https://customer-assets.emergentagent.com/job_audrey-portfolio/artifacts/i6piw3kp_Movement%20-%20Kevin%20Hart%20cover.JPG",
      issueLink: "https://issuu.com/audreyegyptblanc/docs/final_vol_5_with_kevin_hart_cover_p",
      featured: true
    },
    {
      id: 3,
      title: "Larenz Tate Cover Feature",
      publication: "The Movement Magazine REMIXED Vol. 13",
      description: "Newark International Film Festival (NIFF) coverage featuring Larenz Tate and founder Audrey Egypt Young.",
      image: "https://customer-assets.emergentagent.com/job_audrey-portfolio/artifacts/n0la3jus_Movement%20-%20Larenz%20Tate%20cover.JPG",
      issueLink: "https://issuu.com/audreyegyptblanc/docs/niff_ft._larenz_tate_for_print",
      featured: true
    },
    {
      id: 4,
      title: "Bruno Mars Feature Story",
      publication: "The Movement Magazine Vol. 5",
      description: "Life After Losing the Most Important Woman in the World - An exclusive interview with the global superstar.",
      image: "https://customer-assets.emergentagent.com/job_audrey-portfolio/artifacts/vglud9zg_Movement%20-%20Bruno%20Mars%20cover.JPG",
      issueLink: "https://issuu.com/audreyegyptblanc/docs/epk_with_bruno_marz_on_cover_revise",
      featured: true
    },
    {
      id: 5,
      title: "Frankie Beverly Legendary Interview",
      publication: "The Movement Magazine REMIXED Vol. 10",
      description: "Legendary Maze Only Getting Better with Time - A tribute to the soul music icon.",
      image: "https://customer-assets.emergentagent.com/job_audrey-portfolio/artifacts/l8ywcth2_Movement%20-%20Frankie%20Beverly%20cover.JPG",
      issueLink: "https://issuu.com/audreyegyptblanc/docs/frankie_beverly_issue_vol_10",
      featured: true
    },
    {
      id: 6,
      title: "Adrienne Bailon Cover Feature",
      publication: "The Movement Magazine REMIXED Vol. 7",
      description: "Female Hip Hop Honor Awards featuring Shylise Simpson-CEO. The Future - New Artists making their way to the top of the charts.",
      image: "https://customer-assets.emergentagent.com/job_audrey-portfolio/artifacts/0f89blld_Movement%20-%20Adrienne%20Bailon%20cover.JPG",
      issueLink: "https://issuu.com/audreyegyptblanc/docs/vol_7_the_movementmagazine_remixed",
      featured: true
    },
    {
      id: 7,
      title: "Mike Epps Comedy Show Edition",
      publication: "The Movement Magazine REMIXED Vol. 12",
      description: "Comedy Show Edition featuring Mike Epps live at Gotham Comedy Club NYC, plus coverage of KiddiePreneur Awards, music business seminars, and entertainment industry insights.",
      image: "https://customer-assets.emergentagent.com/job_audrey-portfolio/artifacts/kt017qru_The%20Movement%20Magazine%20Vol%2012%20MIKE%20EPPS.png",
      issueLink: "https://issuu.com/audreyegyptblanc/docs/the_movement_remixed_wmikeepps_vol_",
      featured: true
    },
    {
      id: 8,
      title: "George Wallace Trumpet Awards Special",
      publication: "The Movement Magazine REMIXED Vol. 10",
      description: "Trumpet Awards Red Carpet coverage featuring comedic legend George Wallace. An amazing journey showcasing brand growth from dream to full expansion. Hosted by Sharon Sykes, Photos by Sandi DoDreamm, and Filmed and Edited by Audrey Egypt Young.",
      image: "https://customer-assets.emergentagent.com/job_audrey-portfolio/artifacts/44qt57fw_George%20Wallace%20Vol.%2010.png",
      issueLink: "#",
      featured: true
    }
  ]
};

export default mockData;